/* istanbul ignore file - feature in progress */

import { PageBrandedPanel } from '@partful/shared/ui/PageBrandedPanel';
import { PageNavigation } from '@partful/shared/ui/PageNavigation';
import { StandardPageHeader, StandardPageLayout, StandardPageMain } from '@partful/shared/ui/StandardPageLayout';
import { Scene } from './ui/Scene/Scene';

export function ViewInstructionsPage() {
  return (
    <StandardPageLayout>
      <StandardPageHeader>
        <PageBrandedPanel />
        <PageNavigation />
      </StandardPageHeader>
      <StandardPageMain>
        <Scene />
      </StandardPageMain>
    </StandardPageLayout>
  );
}
